var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First-Cashier",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AD03-EMAIL-Dark",
    transform: "translate(-24 -222)",
    fill: "#212121",
    stroke: "#DDD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 245.5a1.5 1.5 0 001.5-1.5v-20a1.5 1.5 0 00-1.5-1.5H26a1.5 1.5 0 00-1.5 1.5v20a1.5 1.5 0 001.5 1.5h20z",
    id: "checkbox"
  })))));
}
SvgCheckbox.displayName = 'Checkbox';
export default SvgCheckbox;